// src/pages/reports/reportRoutes.js
import React from 'react';
const DailyOperationsReport = React.lazy(() => import('./management/DailyOperationsReport'));
const CurrentStockPositionReport = React.lazy(() => import('./management/CurrentStockPositionReport'));
const InwardRegisterReport = React.lazy(() => import('./inward/InwardRegisterReport'));
const GrowerWiseInwardReport = React.lazy(() => import('./inward/GrowerWiseInwardReport'));
const ProductVarietyInwardReport = React.lazy(() => import('./inward/ProductVarietyInwardReport'));
const UnloadingRegisterReport = React.lazy(() => import('./inward/UnloadingRegisterReport'));
const GatePassRegisterReport = React.lazy(() => import('./gate/GatePassRegisterReport'));
const VehicleMovementReport = React.lazy(() => import('./gate/VehicleMovementReport'));
const WeighmentRegisterReport = React.lazy(() => import('./gate/WeighmentRegisterReport'));
const GradingReport = React.lazy(() => import('./quality/GradingReport'));
const InspectionReport = React.lazy(() => import('./quality/InspectionReport'));
const LotRegisterReport = React.lazy(() => import('./lots/LotRegisterReport'));
const LotTraceabilityReport = React.lazy(() => import('./lots/LotTraceabilityReport'));
const WarehouseCapacityReport = React.lazy(() => import('./storage/WarehouseCapacityReport'));
const ChamberOccupancyReport = React.lazy(() => import('./storage/ChamberOccupancyReport'));
const BinStockReport = React.lazy(() => import('./storage/BinStockReport'));
const StorageAllocationReport = React.lazy(() => import('./storage/StorageAllocationReport'));
const StorageReceiptReport = React.lazy(() => import('./storage/StorageReceiptReport'));
const TemperatureLogReport = React.lazy(() => import('./storage/TemperatureLogReport'));
const TemperatureAlertReport = React.lazy(() => import('./storage/TemperatureAlertReport'));
const CrateInventoryReport = React.lazy(() => import('./inventory/CrateInventoryReport'));
const CrateLedgerReport = React.lazy(() => import('./inventory/CrateLedgerReport'));
const StockRegisterReport = React.lazy(() => import('./inventory/StockRegisterReport'));
const StockPurchaseReport = React.lazy(() => import('./inventory/StockPurchaseReport'));
const StockIssueReport = React.lazy(() => import('./inventory/StockIssueReport'));
const StockMovementReport = React.lazy(() => import('./inventory/StockMovementReport'));
const SupplierLedgerReport = React.lazy(() => import('./inventory/SupplierLedgerReport'));
const ProductMasterReport = React.lazy(() => import('./inventory/ProductMasterReport'));
const OutwardRegisterReport = React.lazy(() => import('./outward/OutwardRegisterReport'));
const OutwardRequestReport = React.lazy(() => import('./outward/OutwardRequestReport'));
const OutwardApprovalReport = React.lazy(() => import('./outward/OutwardApprovalReport'));
const OutwardRetrievalReport = React.lazy(() => import('./outward/OutwardRetrievalReport'));
const OutwardGradingPackingReport = React.lazy(() => import('./outward/OutwardGradingPackingReport'));
const OutwardBillingReport = React.lazy(() => import('./outward/OutwardBillingReport'));
const OutwardGatePassReport = React.lazy(() => import('./outward/OutwardGatePassReport'));
const OutwardLoadingReport = React.lazy(() => import('./outward/OutwardLoadingReport'));
const DispatchRegisterReport = React.lazy(() => import('./outward/DispatchRegisterReport'));
const PackedBoxBalanceReport = React.lazy(() => import('./outward/PackedBoxBalanceReport'));
const AgreementRegisterReport = React.lazy(() => import('./growers/AgreementRegisterReport'));
const GrowerMasterReport = React.lazy(() => import('./growers/GrowerMasterReport'));
const AgreementWorkflowReport = React.lazy(() => import('./growers/AgreementWorkflowReport'));
const GrowerStockReport = React.lazy(() => import('./growers/GrowerStockReport'));
const PartyLedgerReport = React.lazy(() => import('./growers/PartyLedgerReport'));
const AgreementAdvanceReport = React.lazy(() => import('./growers/AgreementAdvanceReport'));
const OwnershipTransferReport = React.lazy(() => import('./growers/OwnershipTransferReport'));
const CrmRelationshipReport = React.lazy(() => import('./growers/CrmRelationshipReport'));
const TradingRegisterReport = React.lazy(() => import('./trading/TradingRegisterReport'));
const CommissionReport = React.lazy(() => import('./trading/CommissionReport'));
const RevenueByServiceReport = React.lazy(() => import('./finance/RevenueByServiceReport'));
const UnloadingIncomeReport = React.lazy(() => import('./finance/UnloadingIncomeReport'));
const OutstandingInvoicesReport = React.lazy(() => import('./finance/OutstandingInvoicesReport'));
const CashBookReport = React.lazy(() => import('./finance/CashBookReport'));
const BankBookReport = React.lazy(() => import('./finance/BankBookReport'));
const AdvanceAdjustmentsReport = React.lazy(() => import('./finance/AdvanceAdjustmentsReport'));
const InvoiceRegisterReport = React.lazy(() => import('./finance/InvoiceRegisterReport'));
const GstRegisterReport = React.lazy(() => import('./finance/GstRegisterReport'));
const StorageBillingReport = React.lazy(() => import('./finance/StorageBillingReport'));
const GradingBillingReport = React.lazy(() => import('./finance/GradingBillingReport'));
const InwardGradingFinanceReport = React.lazy(() => import('./finance/InwardGradingFinanceReport'));
const OutwardGradingFinanceReport = React.lazy(() => import('./finance/OutwardGradingFinanceReport'));
const UnbilledGradingReport = React.lazy(() => import('./finance/UnbilledGradingReport'));
const PackingBillingReport = React.lazy(() => import('./finance/PackingBillingReport'));
const ServiceBillingAuditReport = React.lazy(() => import('./finance/ServiceBillingAuditReport'));
const ReceiptRegisterReport = React.lazy(() => import('./finance/ReceiptRegisterReport'));
const PaymentRegisterReport = React.lazy(() => import('./finance/PaymentRegisterReport'));
const ExpenseReport = React.lazy(() => import('./finance/ExpenseReport'));
const SupplierPayablesReport = React.lazy(() => import('./finance/SupplierPayablesReport'));
const PartyReceivablesReport = React.lazy(() => import('./finance/PartyReceivablesReport'));
const CashBankTransactionsReport = React.lazy(() => import('./finance/CashBankTransactionsReport'));
const ProfitLossReport = React.lazy(() => import('./finance/ProfitLossReport'));
const ChequeReconciliationReport = React.lazy(() => import('./finance/ChequeReconciliationReport'));
const ServiceProviderLedgerReport = React.lazy(() => import('./finance/ServiceProviderLedgerReport'));
const CrateChargesReport = React.lazy(() => import('./finance/CrateChargesReport'));
const EmployeeMasterReport = React.lazy(() => import('./hr/EmployeeMasterReport'));
const AttendanceRegisterReport = React.lazy(() => import('./hr/AttendanceRegisterReport'));
const LeaveRegisterReport = React.lazy(() => import('./hr/LeaveRegisterReport'));
const PayrollRegisterReport = React.lazy(() => import('./hr/PayrollRegisterReport'));
const EmployeeAdvanceLoanReport = React.lazy(() => import('./hr/EmployeeAdvanceLoanReport'));
const UnloadingLabourReport = React.lazy(() => import('./hr/UnloadingLabourReport'));
export const COMPANY_REPORT_ROUTES = [
  {
    key: "management_daily",
    path: "/company/reports/management/daily-operations",
    Component: DailyOperationsReport,
    allOf: ['reports_view', "reports_management"],
    anyOf: ["dashboard_view", "reports_generate"],
  },
  {
    key: "management_stock_position",
    path: "/company/reports/management/stock-position",
    Component: CurrentStockPositionReport,
    allOf: ['reports_view', "reports_management"],
    anyOf: ["inventory_view", "lot_view", "storage_view"],
  },
  {
    key: "product_master",
    path: "/company/reports/inventory/product-master",
    Component: ProductMasterReport,
    allOf: ['reports_view', "reports_inventory"],
    anyOf: ["products_view", "inventory_view", "stock_view"],
  },
  {
    key: "grower_master",
    path: "/company/reports/growers/grower-master",
    Component: GrowerMasterReport,
    allOf: ['reports_view', "reports_growers"],
    anyOf: ["growers_view", "customers_view", "agreements_view"],
  },
  {
    key: "inward_register",
    path: "/company/reports/inward/inward-register",
    Component: InwardRegisterReport,
    allOf: ['reports_view', "reports_inward"],
    anyOf: ["inward_view", "inward_operations"],
  },
  {
    key: "inward_grower",
    path: "/company/reports/inward/grower-wise-inward",
    Component: GrowerWiseInwardReport,
    allOf: ['reports_view', "reports_inward"],
    anyOf: ["inward_view", "customers_view", "growers_view"],
  },
  {
    key: "inward_product",
    path: "/company/reports/inward/product-variety-inward",
    Component: ProductVarietyInwardReport,
    allOf: ['reports_view', "reports_inward"],
    anyOf: ["inward_view", "products_view"],
  },
  {
    key: "unloading_register",
    path: "/company/reports/inward/unloading-register",
    Component: UnloadingRegisterReport,
    allOf: ['reports_view', "reports_inward"],
    anyOf: ["unloading_view", "inward_view", "inward_operations"],
  },
  {
    key: "gatepass_register",
    path: "/company/reports/gate/gatepass-register",
    Component: GatePassRegisterReport,
    allOf: ['reports_view', "reports_gate"],
    anyOf: ["gatepass_view", "gate_entry_view", "inward_view"],
  },
  {
    key: "vehicle_movement",
    path: "/company/reports/gate/vehicle-movement",
    Component: VehicleMovementReport,
    allOf: ['reports_view', "reports_gate"],
    anyOf: ["gatepass_view", "dispatch_view", "inward_view", "outward_view"],
  },
  {
    key: "weighment_register",
    path: "/company/reports/gate/weighment-register",
    Component: WeighmentRegisterReport,
    allOf: ['reports_view', "reports_gate"],
    anyOf: ["weighment_view", "weighbridge_operations", "inward_view"],
  },
  {
    key: "grading_report",
    path: "/company/reports/quality/grading-report",
    Component: GradingReport,
    allOf: ['reports_view', "reports_quality"],
    anyOf: ["grading_view", "grading_operations", "outward_view"],
  },
  {
    key: "inspection_report",
    path: "/company/reports/quality/inspection-report",
    Component: InspectionReport,
    allOf: ['reports_view', "reports_quality"],
    anyOf: ["inspection_view", "quality_view", "inward_view"],
  },
  {
    key: "lot_register",
    path: "/company/reports/lots/lot-register",
    Component: LotRegisterReport,
    allOf: ['reports_view', "reports_lots"],
    anyOf: ["lot_view", "inventory_view"],
  },
  {
    key: "lot_traceability",
    path: "/company/reports/lots/lot-traceability",
    Component: LotTraceabilityReport,
    allOf: ['reports_view', "reports_lots"],
    anyOf: ["lot_view", "inventory_view", "outward_view"],
  },
  {
    key: "warehouse_capacity",
    path: "/company/reports/storage/warehouse-capacity",
    Component: WarehouseCapacityReport,
    allOf: ['reports_view', "reports_storage"],
    anyOf: ["warehouse_view", "storage_view"],
  },
  {
    key: "chamber_occupancy",
    path: "/company/reports/storage/chamber-occupancy",
    Component: ChamberOccupancyReport,
    allOf: ['reports_view', "reports_storage"],
    anyOf: ["warehouse_view", "chamber_operations", "storage_view"],
  },
  {
    key: "bin_stock",
    path: "/company/reports/storage/bin-stock",
    Component: BinStockReport,
    allOf: ['reports_view', "reports_storage"],
    anyOf: ["storage_view", "inventory_view", "bin_operations"],
  },
  {
    key: "storage_allocation",
    path: "/company/reports/storage/storage-allocation",
    Component: StorageAllocationReport,
    allOf: ['reports_view', "reports_storage"],
    anyOf: ["storage_view", "storage_allocate", "inventory_view"],
  },
  {
    key: "storage_receipts",
    path: "/company/reports/storage/storage-receipts",
    Component: StorageReceiptReport,
    allOf: ['reports_view', "reports_storage"],
    anyOf: ["storage_view", "billing_view", "inward_view"],
  },
  {
    key: "temperature_log",
    path: "/company/reports/storage/temperature-log",
    Component: TemperatureLogReport,
    allOf: ['reports_view', "reports_storage"],
    anyOf: ["temperature_view", "storage_view", "warehouse_view"],
  },
  {
    key: "temperature_alerts",
    path: "/company/reports/storage/temperature-alerts",
    Component: TemperatureAlertReport,
    allOf: ['reports_view', "reports_storage"],
    anyOf: ["temperature_view", "temperature_alerts", "storage_view"],
  },
  {
    key: "crate_inventory",
    path: "/company/reports/inventory/crate-inventory",
    Component: CrateInventoryReport,
    allOf: ['reports_view', "reports_inventory"],
    anyOf: ["inventory_view", "crate_operations", "crates_view"],
  },
  {
    key: "crate_ledger",
    path: "/company/reports/inventory/crate-ledger",
    Component: CrateLedgerReport,
    allOf: ['reports_view', "reports_inventory"],
    anyOf: ["crates_view", "crate_operations", "finance_view"],
  },
  {
    key: "stock_register",
    path: "/company/reports/inventory/stock-register",
    Component: StockRegisterReport,
    allOf: ['reports_view', "reports_inventory"],
    anyOf: ["stock_view", "stock_manage", "inventory_view"],
  },
  {
    key: "stock_purchases",
    path: "/company/reports/inventory/stock-purchases",
    Component: StockPurchaseReport,
    allOf: ['reports_view', "reports_inventory"],
    anyOf: ["stock_view", "stock_manage", "inventory_view", "finance_view"],
  },
  {
    key: "stock_issues",
    path: "/company/reports/inventory/stock-issues",
    Component: StockIssueReport,
    allOf: ['reports_view', "reports_inventory"],
    anyOf: ["stock_view", "stock_manage", "inventory_view", "grading_view"],
  },
  {
    key: "stock_movement",
    path: "/company/reports/inventory/stock-movement",
    Component: StockMovementReport,
    allOf: ['reports_view', "reports_inventory"],
    anyOf: ["inventory_view", "stock_view", "stock_reports"],
  },
  {
    key: "supplier_ledger",
    path: "/company/reports/inventory/supplier-ledger",
    Component: SupplierLedgerReport,
    allOf: ['reports_view', "reports_inventory"],
    anyOf: ["stock_ledger", "stock_view", "finance_view", "finance_operations"],
  },
  {
    key: "outward_register",
    path: "/company/reports/outward/outward-register",
    Component: OutwardRegisterReport,
    allOf: ['reports_view', "reports_outward"],
    anyOf: ["outward_view", "outward_operations", "dispatch_view"],
  },
  {
    key: "outward_request",
    path: "/company/reports/outward/request-register",
    Component: OutwardRequestReport,
    allOf: ['reports_view', "reports_outward"],
    anyOf: ["outward_view", "outward_create", "dispatch_view"],
  },
  {
    key: "outward_approval",
    path: "/company/reports/outward/approval-register",
    Component: OutwardApprovalReport,
    allOf: ['reports_view', "reports_outward"],
    anyOf: ["outward_view", "outward_approve", "outward_approval"],
  },
  {
    key: "outward_retrieval",
    path: "/company/reports/outward/retrieval-register",
    Component: OutwardRetrievalReport,
    allOf: ['reports_view', "reports_outward"],
    anyOf: ["outward_view", "storage_retrieval", "retrieval_view"],
  },
  {
    key: "outward_grading_packing",
    path: "/company/reports/outward/grading-packing-register",
    Component: OutwardGradingPackingReport,
    allOf: ['reports_view', "reports_outward"],
    anyOf: ["outward_view", "grading_view", "grading_operations"],
  },
  {
    key: "outward_billing",
    path: "/company/reports/outward/billing-register",
    Component: OutwardBillingReport,
    allOf: ['reports_view', "reports_outward"],
    anyOf: ["outward_view", "billing_view", "finance_view", "finance_operations"],
  },
  {
    key: "outward_gatepass",
    path: "/company/reports/outward/gatepass-register",
    Component: OutwardGatePassReport,
    allOf: ['reports_view', "reports_outward"],
    anyOf: ["outward_view", "outward_gatepass", "gatepass_view"],
  },
  {
    key: "outward_loading",
    path: "/company/reports/outward/loading-register",
    Component: OutwardLoadingReport,
    allOf: ['reports_view', "reports_outward"],
    anyOf: ["outward_view", "loading_view", "loading_operations"],
  },
  {
    key: "dispatch_register",
    path: "/company/reports/outward/dispatch-register",
    Component: DispatchRegisterReport,
    allOf: ['reports_view', "reports_outward"],
    anyOf: ["dispatch_view", "outward_view"],
  },
  {
    key: "packed_box_balance",
    path: "/company/reports/outward/packed-box-balance",
    Component: PackedBoxBalanceReport,
    allOf: ['reports_view', "reports_outward"],
    anyOf: ["outward_view", "dispatch_view", "inventory_view"],
  },
  {
    key: "agreement_register",
    path: "/company/reports/growers/agreement-register",
    Component: AgreementRegisterReport,
    allOf: ['reports_view', "reports_growers"],
    anyOf: ["agreements_view", "customers_view", "growers_view"],
  },
  {
    key: "agreement_workflow",
    path: "/company/reports/growers/agreement-workflow",
    Component: AgreementWorkflowReport,
    allOf: ['reports_view', "reports_growers"],
    anyOf: ["agreements_view", "growers_view", "outward_view", "inward_view"],
  },
  {
    key: "grower_stock",
    path: "/company/reports/growers/grower-stock",
    Component: GrowerStockReport,
    allOf: ['reports_view', "reports_growers"],
    anyOf: ["customers_view", "growers_view", "inventory_view", "lot_view"],
  },
  {
    key: "party_ledger",
    path: "/company/reports/growers/party-ledger",
    Component: PartyLedgerReport,
    allOf: ['reports_view', "reports_growers"],
    anyOf: ["finance_view", "finance_operations", "growers_view", "billing_view"],
  },
  {
    key: "agreement_advance",
    path: "/company/reports/growers/agreement-advance",
    Component: AgreementAdvanceReport,
    allOf: ['reports_view', "reports_growers"],
    anyOf: ["agreements_view", "finance_view", "payments_view", "growers_view"],
  },
  {
    key: "ownership_transfer",
    path: "/company/reports/growers/ownership-transfer",
    Component: OwnershipTransferReport,
    allOf: ['reports_view', "reports_growers"],
    anyOf: ["stock_transfer", "inventory_transfer", "finance_view", "growers_view"],
  },
  {
    key: "crm_relationships",
    path: "/company/reports/growers/crm-relationships",
    Component: CrmRelationshipReport,
    allOf: ['reports_view', "reports_growers"],
    anyOf: ["growers_view", "crm_view", "customers_view", "agreements_view"],
  },
  {
    key: "trading_register",
    path: "/company/reports/trading/trading-register",
    Component: TradingRegisterReport,
    allOf: ['reports_view', "reports_trading"],
    anyOf: ["purchase_operations", "sales_operations", "trading_view"],
  },
  {
    key: "commission_report",
    path: "/company/reports/trading/commission-report",
    Component: CommissionReport,
    allOf: ['reports_view', "reports_trading"],
    anyOf: ["purchase_operations", "sales_operations", "trading_reports"],
  },
  { key: "revenue_by_service", path: "/company/reports/finance/revenue-by-service", Component: RevenueByServiceReport, allOf: ['reports_view', "reports_finance"], anyOf: ["finance_view","billing_view","reports_generate"] },
  { key: "unloading_income", path: "/company/reports/finance/unloading-income", Component: UnloadingIncomeReport, allOf: ['reports_view', "reports_finance"], anyOf: ["finance_view","billing_view","inward_view"] },
  { key: "outstanding_invoices", path: "/company/reports/finance/outstanding-invoices", Component: OutstandingInvoicesReport, allOf: ['reports_view', "reports_finance"], anyOf: ["finance_view","billing_view","payments_view"] },
  { key: "cash_book", path: "/company/reports/finance/cash-book", Component: CashBookReport, allOf: ['reports_view', "reports_finance"], anyOf: ["finance_view","accounts_view","finance_operations"] },
  { key: "bank_book", path: "/company/reports/finance/bank-book", Component: BankBookReport, allOf: ['reports_view', "reports_finance"], anyOf: ["finance_view","accounts_view","finance_operations"] },
  { key: "advance_adjustments", path: "/company/reports/finance/advance-adjustments", Component: AdvanceAdjustmentsReport, allOf: ['reports_view', "reports_finance"], anyOf: ["finance_view","payments_view","agreements_view"] },
  {
    key: "invoice_register",
    path: "/company/reports/finance/invoice-register",
    Component: InvoiceRegisterReport,
    allOf: ['reports_view', "reports_finance"],
    anyOf: ["invoices_view", "finance_view", "finance_operations"],
  },
  {
    key: "gst_register",
    path: "/company/reports/finance/gst-register",
    Component: GstRegisterReport,
    allOf: [],
    anyOf: ["gst_reports_view", "reports_finance", "finance_view", "finance_operations", "hd_orchids_gst_view"],
  },
  {
    key: "storage_billing",
    path: "/company/reports/finance/storage-billing",
    Component: StorageBillingReport,
    allOf: ['reports_view', "reports_finance"],
    anyOf: ["billing_view", "invoices_view", "finance_view"],
  },
  {
    key: "grading_billing",
    path: "/company/reports/finance/grading-billing",
    Component: GradingBillingReport,
    allOf: ['reports_view', "reports_finance"],
    anyOf: ["billing_view", "invoices_view", "finance_view"],
  },
  {
    key: "inward_grading_finance",
    path: "/company/reports/finance/inward-grading-finance",
    Component: InwardGradingFinanceReport,
    allOf: ['reports_view', "reports_finance"],
    anyOf: ["billing_view", "invoices_view", "finance_view", "grading_view"],
  },
  {
    key: "outward_grading_finance",
    path: "/company/reports/finance/outward-grading-finance",
    Component: OutwardGradingFinanceReport,
    allOf: ['reports_view', "reports_finance"],
    anyOf: ["billing_view", "invoices_view", "finance_view", "outward_view"],
  },
  {
    key: "unbilled_grading",
    path: "/company/reports/finance/unbilled-grading",
    Component: UnbilledGradingReport,
    allOf: ['reports_view', "reports_finance"],
    anyOf: ["billing_view", "invoices_view", "finance_view", "grading_view"],
  },
  {
    key: "packing_billing",
    path: "/company/reports/finance/packing-billing",
    Component: PackingBillingReport,
    allOf: ['reports_view', "reports_finance"],
    anyOf: ["finance_view", "billing_view", "grading_view", "outward_view"],
  },
  {
    key: "service_billing_audit",
    path: "/company/reports/finance/service-billing-audit",
    Component: ServiceBillingAuditReport,
    allOf: ['reports_view', "reports_finance"],
    anyOf: ["finance_view", "finance_operations", "billing_view", "reports_generate"],
  },
  {
    key: "receipt_register",
    path: "/company/reports/finance/receipt-register",
    Component: ReceiptRegisterReport,
    allOf: ['reports_view', "reports_finance"],
    anyOf: ["billing_view", "payments_view", "finance_view"],
  },
  {
    key: "payment_register",
    path: "/company/reports/finance/payment-register",
    Component: PaymentRegisterReport,
    allOf: ['reports_view', "reports_finance"],
    anyOf: ["payments_view", "finance_view", "finance_operations"],
  },
  {
    key: "expense_report",
    path: "/company/reports/finance/expense-report",
    Component: ExpenseReport,
    allOf: ['reports_view', "reports_finance"],
    anyOf: ["finance_operations", "cash_operations", "finance_view"],
  },
  {
    key: "supplier_payables",
    path: "/company/reports/finance/supplier-payables",
    Component: SupplierPayablesReport,
    allOf: ['reports_view', "reports_finance"],
    anyOf: ["finance_view", "finance_operations", "stock_ledger", "stock_view"],
  },
  {
    key: "party_receivables",
    path: "/company/reports/finance/party-receivables",
    Component: PartyReceivablesReport,
    allOf: ['reports_view', "reports_finance"],
    anyOf: ["finance_view", "finance_operations", "billing_view", "growers_view"],
  },
  {
    key: "cash_bank_transactions",
    path: "/company/reports/finance/cash-bank-transactions",
    Component: CashBankTransactionsReport,
    allOf: ['reports_view', "reports_finance"],
    anyOf: ["finance_view", "finance_operations", "accounts_view", "accounts_manage"],
  },
  {
    key: "profit_loss",
    path: "/company/reports/finance/profit-loss",
    Component: ProfitLossReport,
    allOf: ['reports_view', "reports_finance"],
    anyOf: ["finance_view", "finance_operations", "finance_reports", "reports_generate"],
  },
  {
    key: "crate_charges",
    path: "/company/reports/finance/crate-charges",
    Component: CrateChargesReport,
    allOf: ['reports_view', "reports_finance"],
    anyOf: ["finance_view", "billing_view", "crates_view", "inventory_view"],
  },
  {
    key: "cheque_reconciliation",
    path: "/company/reports/finance/cheque-reconciliation",
    Component: ChequeReconciliationReport,
    allOf: ['reports_view', "reports_finance"],
    anyOf: ["finance_view", "finance_operations", "bank_reconciliation_manage"],
  },
  {
    key: "service_provider_ledger",
    path: "/company/reports/finance/service-provider-ledger",
    Component: ServiceProviderLedgerReport,
    allOf: ['reports_view', "reports_finance"],
    anyOf: ["finance_view", "finance_operations", "reports_generate"],
  },
  {
    key: "employee_master",
    path: "/company/reports/hr/employee-master",
    Component: EmployeeMasterReport,
    allOf: ['reports_view', "reports_hr"],
    anyOf: ["employees_view", "hr_operations"],
  },
  {
    key: "attendance_register",
    path: "/company/reports/hr/attendance-register",
    Component: AttendanceRegisterReport,
    allOf: ['reports_view', "reports_hr"],
    anyOf: ["attendance_view", "attendance_operations", "hr_operations"],
  },
  {
    key: "leave_register",
    path: "/company/reports/hr/leave-register",
    Component: LeaveRegisterReport,
    allOf: ['reports_view', "reports_hr"],
    anyOf: ["leave_operations", "hr_operations"],
  },
  {
    key: "unloading_labour",
    path: "/company/reports/hr/unloading-labour",
    Component: UnloadingLabourReport,
    allOf: ['reports_view', "reports_hr"],
    anyOf: ["payroll_operations", "hr_operations", "finance_view", "inward_admin"],
  },
  {
    key: "employee_advance_loan",
    path: "/company/reports/hr/employee-advance-loan",
    Component: EmployeeAdvanceLoanReport,
    allOf: ['reports_view', "reports_hr"],
    anyOf: ["payroll_operations", "hr_operations", "finance_view", "finance_operations"],
  },
  {
    key: "payroll_register",
    path: "/company/reports/hr/payroll-register",
    Component: PayrollRegisterReport,
    allOf: ['reports_view', "reports_hr"],
    anyOf: ["payroll_operations", "hr_operations"],
  },
];

export default COMPANY_REPORT_ROUTES;
